import React from "react";
import "./payment-item.css";
import { ArrowDownIconV1, ArrowUpIconV1 } from "images/image-component";
import formatDate, { formatTime } from "utils/DateUtil";
import { Payment } from "types/payment";
import { getPaymentKind, PAYMENT_KIND_LABEL } from "utils/payment";
import { useRedeemAddress } from "features/config/useAppConfig";

interface Props {
  payment: Payment;
  /** The tx list is fetched per-token, so one symbol covers every row. */
  tokenSymbol: string;
  onClick: (payment: Payment) => void;
}

function PaymentItem({ payment, tokenSymbol, onClick }: Props) {
  const isIn = payment.dir === "in";
  const redeemAddress = useRedeemAddress();
  // Sale (in) · Redeem/Refund (out) — decided by the destination address.
  const kind = getPaymentKind(payment, redeemAddress);
  return (
    <div className="payment-item" onClick={() => onClick(payment)}>
      <div className={`payment-item__icon ${isIn ? "in" : "out"}`}>
        {isIn ? <ArrowDownIconV1 size={16} /> : <ArrowUpIconV1 size={16} />}
      </div>
      <div className="payment-item__meta">
        <div className="payment-item__from">{PAYMENT_KIND_LABEL[kind]}</div>
        {/* <div className="payment-item__from">{payment.from}</div> */}
        <div className="payment-item__time">
          {formatDate(new Date(payment.time * 1000))} -{" "}
          {formatTime(new Date(payment.time * 1000))}
          {/* · tx {payment.txId} */}
        </div>
      </div>
      <div className={`payment-item__amt ${isIn ? "in" : "out"}`}>
        {payment.value.toFixed(2)} {tokenSymbol}
      </div>
    </div>
  );
}

export default PaymentItem;
